import { icons } from "lucide-react";

export const getAllIconNames = (): string[] => Object.keys(icons);

export const isLucideIcon = (name: string): boolean => name in icons;
